<template>
	<v-layout
		row
		wrap
		justify-center
		align-center
	>
		<v-flex xs12 xl8>
			<div class="headline">User Preferences</div>
			<div>Add functionality to your account with these advanced features:</div>
			<v-layout row wrap class="mt-4">
				<ListAndCard
					v-for="skill in skills"
					:key="skill.id"
					:image="skill.image"
					:image-text="skill.name"
					:show="!skill.super"
				>
					<div slot="title">
						<div class="headline">{{ skill.name }}</div>
						<div v-html="skill.description"/>
					</div>
					<template slot="actions">
						<v-switch
							v-model="skill.value"
							hide-details
							color="secondary"
							class="ma-0 pa-1"
							@change="updateSkills(skill)"
						/>
					</template>
				</ListAndCard>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
import ListAndCard from '@/components/ListAndCard';
import ReportPublicationsImg from '@/assets/publications.svg';
import KeywordsImg from '@/assets/keywords.svg';
import SearchImg from '@/assets/search.svg';
import TwitterImg from '@/assets/twitter.svg';
import ImportanceImg from '@/assets/importance.svg';

export default {
	components: {
		ListAndCard,
	},
	data() {
		return {
			uid: this.$ls.get('id'),
			skills: [
				{
					id: 'report_publications',
					name: 'Publications',
					image: ReportPublicationsImg,
					description: `Enables you to view a list of all of the publications represented in each report
						along with reach data (based on an estimate of unique monthly visitors for each site).`,
					value: false,
				},
				{
					id: 'keywords',
					name: 'Keywords',
					image: KeywordsImg,
					description: `If you would like specific keywords shown in bold throughout your report you can
						enable the keyword menu. Information on
						<a href="https://support.reportmule.com/en/docs/15-keywords" target="_blank">creating your keywords</a>
						can be found in our knowledge base.`,
					value: false,
				},
				{
					id: 'importance',
					name: 'Article Importance',
					image: ImportanceImg,
					description: 'Adds the ability to adjust the level of importance each article has.',
					value: false,
				},
				{
					id: 'hide_dashboard',
					name: 'Hide Dashboard',
					description: 'Hides Dashboard, allowing you to start right at the projects page.',
					value: false,
				},
				{
					id: 'author_issue',
					name: 'Article Author Issue',
					description: 'Show issue on an article if the author is blank.',
					value: false,
				},
				{
					id: 'search',
					name: 'Search',
					image: SearchImg,
					description: 'Adds the ability to search across all of your reports.',
					value: false,
					super: true,
				},
				{
					id: 'twitter',
					name: 'Twitter Stats',
					image: TwitterImg,
					description: `Twitter removed sharing data from their platform several years ago. We're able
						to get a rough estimate of Twitter shares up to 99. Beyond that we simply indicate 99+. As
						this is imprecise and may cause more confusion than clarity, by default this feature is inactive.`,
					value: false,
					super: true,
				},
				{
					id: 'clipboard_add',
					name: 'Clipboard Add',
					description: 'Clipboard add stuff.',
					value: false,
					super: true,
				},
			],
		};
	},
	created() {
		const skills = this.$ls.get('skills');

		if (!skills || skills.uid !== this.uid) {
			this.$ls.set('skills', { uid: this.uid, items: [] });
		}
		else {
			skills.items.forEach((item) => {
				const exists = this.skills.find(skill => skill.id === item);
				if (exists) {
					exists.value = true;
				}
			});
		}
	},
	methods: {
		updateSkills(clickedSkill) {
			// Clipboard Add is special
			if (clickedSkill.id === 'clipboard_add' && clickedSkill.value === true) {
				this.requestClipboard();
			}

			if (clickedSkill.value) {
				this.$notify('success', `Enabled ${clickedSkill.name} for your account.`);
			}
			else {
				this.$notify('success', `Disabled ${clickedSkill.name} for your account.`);
			}

			const skills = this.skills
				.filter(skill => skill.value)
				.map(skill => skill.id);

			const skillsObj = { uid: this.uid, items: skills };

			this.$ls.set('skills', skillsObj);
			this.$store.set('skills', skillsObj);
		},
		requestClipboard() {
			navigator.clipboard.readText().then().catch((e) => {
				dump(e);
			});
		},
	},
};
</script>

<style>

</style>
